import { useRef as t, useEffect as r } from "react";
const f = () => {
  const e = t(!0);
  return r(
    () => () => {
      e.current = !1;
    },
    []
  ), e;
};
export {
  f as default
};
